import StarSolid from './StarSolid'

export default StarSolid
// eslint-disable-next-line import/export
export * from './StarSolid'
